import { Datagrid, EditButton, List, ShowButton, TextField, TextInput, useTranslate } from "react-admin";

import { rowStyles } from "../../utils/rowStyles";
import { ListPagination } from "../../utils/components/ListPagination";

import { ListActions } from "../../common/ListActions";

export function GenreList(): JSX.Element {
    const t = useTranslate();

    const filters = [<TextInput key="searchTerms-filter" label={t("resources.genre.fields.name")} source="searchTerms" alwaysOn />];

    return (
        <>
            <List pagination={<ListPagination />} perPage={20} filters={filters} actions={<ListActions />}>
                <Datagrid rowStyle={rowStyles}>
                    <TextField source="name" />
                    <TextField source="description" />
                    <EditButton />
                    <ShowButton />
                </Datagrid>
            </List>
        </>
    );
}
